import { createFileRoute } from "@tanstack/react-router";
import { HomePage, homeLoader, homeHeadDa } from "@/pages/HomePage";

export const Route = createFileRoute("/")({
  loader: homeLoader,
  head: homeHeadDa,
  component: HomePage,
});
